const possibleTemplates = [1];

const isPossibleTemplate: (template: number) => boolean = (
  template: number
) => {
  return possibleTemplates.includes(template);
};

export default isPossibleTemplate;
